import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';
import { AdminDashboardService } from '../../services/admin-dashboard.service';

@Component({
  selector: 'app-email-log',
  templateUrl: './mail-log.component.html',
  styleUrls: ['./mail-log.component.scss']
})
export class MailLogComponent implements OnInit {
  public selectedUser: any;
  public user: any;
  public users: [];
  public searchText: string;
  public activatedText: string;
  public showAllUsers: boolean;
  public userDetail: boolean;
  public message: string;
  public usersFound: boolean;
  public usersFoundArray: any;
  public isSearching: boolean = false;
  public dataIsLoaded: boolean;

  constructor(
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private ZpDataService: ZpDataService,
    private admin: AdminDashboardService, public themeService: ThemeService) {
    this.users = [];
  }

  async ngOnInit() {
    this.showAllUsers = true
    await this.ZpDataService.getAllUsers().then(allUsers => {
      this.admin.users = allUsers.users;
      this.users = this.admin.users;
    });
    this.ZpDataService.getUser().then(user => {
      this.user = user;
    });
  }


  onSelect(dataUser) {
    this.showAllUsers = false;
    this.selectedUser = dataUser
    this.userDetail = true
  }

  displayUserData(event) {
    console.log(event, '- User data from child component')
  }

  backFromDetailUser() {
    this.showAllUsers = true
    this.userDetail = false
  }

  async searchByLastName(serachData) {
    this.dataIsLoaded = false
    this.isSearching = true;
    let data = await this.ZpDataService.findUsers(null, serachData);
    this.dataIsLoaded = true
    if (data.success && data.users.length > 0) {
      this.usersFoundArray = data.users;
      this.usersFound = true
    } 
    else 
      this.usersFound = false
      this.message = 'This user does not exist.'
    
  }

  backToTable() {
    this.isSearching = false;
  }
}
